function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9583;}.cls-2{fill:#9ae3f0;}.cls-3{fill:#495771;stroke:#495771;stroke-miterlimit:10;}.cls-4{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "ParcelPostInsurance");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M74.41,87.7a1,1,0,0,0,1.12,0l6.76-4.56a21,21,0,0,0,9.43-17.33V51.24a.92.92,0,0,0-.61-.86l-15.78-6a1,1,0,0,0-.72,0l-15.78,6a.92.92,0,0,0-.61.86V65.81a21,21,0,0,0,9.43,17.33Z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "62.97 4.42 62.97 4.59 52.09 20.42 51.97 20.42 30.09 20.42 40.97 4.59 40.97 4.42 62.97 4.42"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "51.97 20.59 51.97 42.42 40.97 34.42 29.97 42.42 29.97 20.59 30.09 20.42 51.97 20.42 51.97 20.59"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "30.09 20.42 29.97 20.59 29.97 20.42 30.09 20.42"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M79,40.09a1,1,0,0,1-1-1V20.42a1,1,0,0,1,2,0V39.09A1,1,0,0,1,79,40.09Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M59,85.42H5a3,3,0,0,1-3-3v-62H4v62a1,1,0,0,0,1,1H59Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M90,43.42H88V7.91L79.82,21a1,1,0,0,1-.85.47H3a1,1,0,0,1-1-1,1,1,0,0,1,.18-.57l11-16A1,1,0,0,1,14,3.42H89a1,1,0,0,1,1,1Zm-85.1-24H78.42l8.75-14H14.5Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M75,96.58a2.05,2.05,0,0,1-1.13-.34l-9.51-6.48A31.5,31.5,0,0,1,59,85.11a29.81,29.81,0,0,1-8-20.26V46.92a1.91,1.91,0,0,1,1.25-1.79L74.3,36.71a2,2,0,0,1,1.44,0l22.08,8.42A1.92,1.92,0,0,1,99,46.92V64.84A30.25,30.25,0,0,1,85.61,89.75L76.1,96.23A2,2,0,0,1,75,96.58Zm0-58L52.88,47V64.85a27.8,27.8,0,0,0,7.48,18.9h0a29.15,29.15,0,0,0,5.06,4.35L75,94.58l9.52-6.48A28.26,28.26,0,0,0,97,64.84V46.92l-7.42-2.77Z"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "74.3 73.67 66.76 66.29 68.16 64.86 74.16 70.73 83.19 59.97 84.73 61.26 74.3 73.67"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  width: 100,
  height: 100
});

var SvgParcelPostInsurance = function SvgParcelPostInsurance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParcelPostInsurance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ParcelPostInsurance.432bc08a.svg";
export { ForwardRef as ReactComponent };